import { fetchAssortment } from '@/utils/http/fetchAssortment';
import { Thunk } from '@/redux/types';
import { selectFilter } from '../getters/selectFilter';
import {
  ProductTypesActionTypes,
  ProductTypesAssortmentSetAction,
  ProductTypesAssortmentSetStatusAction,
} from '../types';

export const fetchProductTypeAssortmentAction: Thunk<
  Promise<void>,
  ProductTypesAssortmentSetStatusAction | ProductTypesAssortmentSetAction
> = (dispatch, getState) => {
  dispatch({
    type: ProductTypesActionTypes.PRODUCT_TYPES_ASSORTMENT_SET_STATUS,
    status: 'loading',
  });

  const filter = selectFilter(getState());
  return fetchAssortment(filter, getState).then((assortment) => {
    dispatch({
      type: ProductTypesActionTypes.PRODUCT_TYPES_ASSORTMENT_SET,
      assortment,
    });
  });
};
